/*** IMPORTS FROM imports-loader ***/


'use strict';

var bind = require('function-bind');
var define = require('define-properties');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;




//////////////////
// WEBPACK FOOTER
// ../~/string.prototype.trim/index.js
// module id = 174
// module chunks = 3